/* sf-peak.js (30.09.2026, Task SF-PEAK-OPUS-20260929)
   Verhalten fuer die PEAK-Bausteine:
   - [data-sfpk-nut]  Reiter je Geschmack in "Inhaltsstoffe & Naehrwerte"; folgt der Variantenwahl
                      der Buybox (theme.pubsub variantChange), ohne die Buybox selbst zu veraendern.
   - [data-sfpk-card] Cross-Sell-Karte: Geschmack waehlen, Preis/Bild/Bestand nachziehen, einzeln in den Warenkorb.
   - [data-sfpk-set]  Kombi: mehrere Produkte, je Produkt Geschmack waehlen, ein Klick legt alle (je 1 Stk.) ab.
   Warenkorb wie ProductForm in assets/theme.js: /cart/add mit sections, danach cartUpdate + Drawer oeffnen.
   Nichts wird automatisch in den Warenkorb gelegt; jede Aktion braucht einen Klick. */
(function () {
  'use strict';
  if (window.__sfpkInit) return;
  window.__sfpkInit = true;

  var money = function (cents) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  };

  /* ---------------------------------------------------------------- Reiter */
  function selectTab(root, key, focus) {
    var tabs = root.querySelectorAll('[data-sfpk-tab]');
    var found = false;
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-sfpk-tab') === String(key);
      if (on) found = true;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    if (!found) return false;
    root.querySelectorAll('[data-sfpk-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-sfpk-panel') !== String(key);
    });
    return true;
  }

  function initNut(root) {
    if (root.__sfpk) return; root.__sfpk = true;
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sfpk-tab]');
      if (t && root.contains(t)) selectTab(root, t.getAttribute('data-sfpk-tab'));
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sfpk-tab]'));
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      selectTab(root, n.getAttribute('data-sfpk-tab'), true);
    });
  }

  function onVariantChange(payload) {
    var d = payload && payload.data;
    if (!d || !d.variant) return;
    document.querySelectorAll('[data-sfpk-nut]').forEach(function (root) {
      if (String(root.getAttribute('data-product-id')) !== String(d.productId)) return;
      selectTab(root, d.variant.id);
    });
  }

  /* ---------------------------------------------------------- Karten/Kombis */
  function optionOf(sel) { return sel && sel.options[sel.selectedIndex]; }

  function syncCard(card) {
    var sel = card.querySelector('[data-sfpk-variant]');
    var btn = card.querySelector('[data-sfpk-add]');
    var opt = optionOf(sel);
    if (!opt) return;
    var price = card.querySelector('[data-sfpk-price]');
    var unit = card.querySelector('[data-sfpk-unit]');
    var img = card.querySelector('[data-sfpk-img]');
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    if (unit) { unit.textContent = opt.dataset.unit || ''; unit.hidden = !opt.dataset.unit; }
    if (img && opt.dataset.img) { img.src = opt.dataset.img; if (opt.dataset.srcset) img.srcset = opt.dataset.srcset; }
    if (btn) {
      var ok = opt.dataset.available === 'true';
      btn.disabled = !ok;
      var label = btn.querySelector('[data-sfpk-label]');
      if (label) label.textContent = ok ? (btn.dataset.labelAdd || 'In den Warenkorb') : (btn.dataset.labelSoldout || 'Ausverkauft');
    }
  }

  function syncSet(set) {
    var total = 0, ok = true;
    set.querySelectorAll('[data-sfpk-item]').forEach(function (it) {
      var sel = it.querySelector('[data-sfpk-variant]');
      var opt = optionOf(sel);
      var cents = opt ? parseInt(opt.dataset.cents, 10) : parseInt(it.dataset.cents, 10);
      var avail = opt ? opt.dataset.available === 'true' : it.dataset.available === 'true';
      if (!avail) ok = false;
      total += isNaN(cents) ? 0 : cents;
      var meta = it.querySelector('[data-sfpk-price]');
      if (meta && opt && opt.dataset.price) meta.textContent = opt.dataset.price;
    });
    var sum = set.querySelector('[data-sfpk-sum]');
    if (sum) sum.textContent = money(total);
    var free = set.querySelector('[data-sfpk-free]');
    if (free) {
      var min = parseInt(free.dataset.min, 10);
      free.hidden = !(min && total >= min);
    }
    var btn = set.querySelector('[data-sfpk-add]');
    if (btn) {
      btn.disabled = !ok;
      var label = btn.querySelector('[data-sfpk-label]');
      if (label) label.textContent = ok ? (btn.dataset.labelAdd || 'Alle in den Warenkorb') : (btn.dataset.labelSoldout || 'Nicht alles verfügbar');
    }
  }

  function collect(scope) {
    var items = [];
    var set = scope.matches('[data-sfpk-set]');
    var nodes = set ? scope.querySelectorAll('[data-sfpk-item]') : [scope];
    nodes.forEach(function (n) {
      var sel = n.querySelector('[data-sfpk-variant]');
      var id = sel ? sel.value : n.getAttribute('data-variant-id');
      if (!id) return;
      var item = { id: parseInt(id, 10), quantity: 1 };
      // PEAK-Ware (Karten immer, Kombi-Positionen mit data-peak="true") versendet PEAK selbst:
      // _sf_peak macht sie fuer assets/stl-order-type-guard.js neben einer Vorbestellung zulaessig.
      if (n.getAttribute('data-peak') !== 'false') item.properties = { _sf_peak: '1' };
      items.push(item);
    });
    return items;
  }

  function add(btn) {
    var scope = btn.closest('[data-sfpk-set]') || btn.closest('[data-sfpk-card]');
    if (!scope || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var msg = scope.querySelector('[data-sfpk-msg]');
    if (msg) msg.textContent = '';
    var items = collect(scope);
    if (!items.length) return;

    // Vorbestell-Warenkorb (assets/stl-order-type-guard.js): lieferbare STARKFELD-Ware (z. B. Boots) darf nicht dazu, PEAK schon.
    // Vorher pruefen, damit der Hinweis hier erscheint und der Fokus nicht in die Buybox springt.
    var guard = window.stlOrderTypeGuard;
    var hasOwnGoods = items.some(function (i) { return !i.properties; });
    if (guard && guard.state && guard.state.hasPreorder && hasOwnGoods) {
      var gcfg = window.__stlOrderTypeGuardConfig || {};
      if (msg) msg.textContent = gcfg.message || 'Vorbestellungen und sofort verfügbare Artikel müssen getrennt bestellt werden.';
      return;
    }

    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var routes = (window.theme && theme.routes) || {};
    var addUrl = routes.cart_add_url || '/cart/add';
    var cartUrl = routes.cart_url || '/cart';
    btn.setAttribute('aria-busy', 'true');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { j = j || {}; j.__ok = r.ok; return j; });
      })
      .then(function (res) {
        // /cart/add antwortet bei Fehlern mit HTTP 422, teils ohne Feld "status" (z. B. {"errors":"Warenkorb-Fehler"})
        if (!res.__ok || res.status) {
          var d = res.description;
          if (!d || /Variante nicht finden|Warenkorb-Fehler/i.test(d)) d = 'Das ist gerade nicht bestellbar. Bitte versuch es später noch einmal.';
          if (msg) msg.textContent = d;
          if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartError, { source: 'sf-peak', errors: res.errors || res.description, message: res.message });
          return;
        }
        return fetch(cartUrl, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cart.sections = res.sections;
            if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'sf-peak', cart: cart });
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res } }));
            btn.classList.add('is-added');
            var drawer = document.querySelector('cart-drawer');
            var pageCart = window.theme && theme.settings && theme.settings.cartType === 'page';
            if (!pageCart && drawer && typeof drawer.show === 'function') drawer.show(btn);
            else window.location.href = cartUrl;
          });
      })
      .catch(function (err) {
        if (msg) msg.textContent = (err && err.message) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
      })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }

  /* ------------------------------------------------------------ Blaettern */
  function initRail(rail) {
    if (rail.__sfpk) return; rail.__sfpk = true;
    var list = rail.querySelector('[data-sfpk-list]');
    var prev = rail.querySelector('[data-sfpk-prev]');
    var next = rail.querySelector('[data-sfpk-next]');
    if (!list || !prev || !next) return;
    var step = function () { var c = list.querySelector('[data-sfpk-card]'); return c ? c.getBoundingClientRect().width + 16 : list.clientWidth; };
    var upd = function () {
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      var nav = rail.querySelector('.sfpk-nav');
      if (nav) nav.hidden = list.scrollWidth <= list.clientWidth + 2;
    };
    prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); });
    list.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sfpk-nut]').forEach(initNut);
    (scope || document).querySelectorAll('[data-sfpk-rail]').forEach(initRail);
    (scope || document).querySelectorAll('[data-sfpk-set]').forEach(syncSet);
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-sfpk-variant]');
    if (!sel) return;
    var set = sel.closest('[data-sfpk-set]');
    if (set) { syncSet(set); return; }
    var card = sel.closest('[data-sfpk-card]');
    if (card) syncCard(card);
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sfpk-add]');
    if (btn) { e.preventDefault(); add(btn); }
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  var subscribe = function () {
    if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, onVariantChange);
      return true;
    }
    return false;
  };
  if (!subscribe()) document.addEventListener('DOMContentLoaded', subscribe, { once: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
